import React from 'react'
import { Link } from 'react-router-dom'
import Constant, { getTypeTags } from '../../Constant'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import axios from 'axios'
import Moment from 'react-moment'
import Loader from '../../common/Loader'
import CustomFooter from '../../common/TableBottom'
import Select from 'react-select'
import Button from '../../common/CustomComponents/Button'

class BookingV2 extends React.Component {
  state = {
    country_list: [],
    Booking_data: [],
    users_data: [],
    model: false,
    open: false,
    limit: 10,
    pageNumber: 0,
    disabled: false,
    keyword: '',
    bookingStatus: '',
    country: '',
    cruiseId: null,
    cruiseList: [],
    nationality: [],
    nationalityId: '',
    type_tag: '',
    booking_date: undefined,
    customer_phone: null,

    isSearching: false,
    isCancelled: false,
    totalCount: 0,
    totalPages: 0,
  }

  debounceTimeout = null

  componentDidMount() {
    this.getBookingList()
    this.getCountries()
    this.getCaptainNationality()
  }

  componentWillUnmount() {
    // Clear timeout on unmount
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout)
    }
  }

  getBookingList = async () => {
    this.setState({
      isSearching: true,
      open: true,
      Booking_data: [],
    })

    await axios
      .get(Constant.getAPI() + `/admin/list-bookings-v3`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        params: {
          booking_date: this.state.booking_date,
          // customer_phone: this.state.customer_phone,
          nationalityId: this.state.nationalityId,
          cruiseId: this.state?.cruiseId?.value || '',
          type_tag: this.state.type_tag,
          country: this.state.country,
          status: this.state.bookingStatus,
          keyword: this.state.keyword,
          pageNumber: this.state.pageNumber,
          limit: this.state.limit,
        },
      })
      .then((res) => {
        if (res.data.success) {
          res.data.data.forEach((booking) => {
            if (booking.booking_status == 'Cancelled' || booking.booking_cancel) {
              booking.booking_status = 'Cancelled'
            } else if (booking.booking_status == 'Postponed') {
              booking.booking_status = 'Postponed'
            } else if (booking.booking_status == 'Confirmed') {
              booking.booking_status = 'Confirmed'
            } else if (booking.booking_status == 'Successful') {
              booking.booking_status = 'Successful'
            } else if (booking.booking_status == 'Pending' && booking.payment_status == true) {
              booking.booking_status = 'Pending'
            } else if (booking.booking_status == 'Sailed') {
              booking.booking_status = 'Sailed'
            } else {
              booking.booking_status = 'Pending'
            }
          })

          this.setState({
            Booking_data: res.data.data,
            open: false,
            disabled: !res.data.data?.length > 0,
            totalCount: res.data.pagination?.count || 0,
            totalPages: res.data.pagination?.pages || 0,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
        this.setState({
          open: false,
        })
      })
      .finally(() => {
        this.setState({
          isSearching: false,
        })
      })
  }

  getCountries = async () => {
    await axios
      .get(Constant.getAPI() + '/multi-country/list-countries?show_all_countries=true', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name:
            localStorage.getItem('loged_In_role') === 'super-admin'
              ? ''
              : `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          this.setState({
            country_list:
              localStorage.getItem('loged_In_role') == 'concierge'
                ? res.data.data.filter((ele) => ele.country_short_name === localStorage.getItem('countryShortName'))
                : res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleChange = (event) => {
    event.persist()
    const fieldName = event?.target?.name
    const fieldValue = event?.target?.value

    this.setState({
      [fieldName]: fieldValue,
    })

    if (fieldName == 'country') {
      this.setState({
        cruiseList: [],
        cruiseId: null,
      })
      if (event.target.value != '') {
        this.getCruiseList(event.target.value)
      }
    }

    // Auto-search with debounce for all filters except keyword
    if (fieldName !== 'keyword') {
      this.triggerAutoSearch()
    } else {
      // Debounce keyword search
      this.triggerDebouncedSearch()
    }
  }

  getCruiseList = async (country = '') => {
    await axios
      .get(Constant.getAPI() + '/cruise/list-cruise', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name:
            localStorage.getItem('loged_In_role') === 'super-admin'
              ? ''
              : `${localStorage.getItem('countryShortName')}`,
        },
        params: {
          country: country,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          this.setState({
            cruiseList: res.data.data.map((itm) => ({
              label: `${itm.cruise_name_en}/${itm.cruise_name_ar}`,
              value: itm.id,
            })),
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getCaptainNationality = async () => {
    await axios
      .get(Constant.getAPI() + '/admin/get-nationality', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            nationality: res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  changeBookingTagAndStatus = async (event, rowData) => {
    let data = {}

    let id = rowData[0]
    let temp_data = this.state.Booking_data
    temp_data.forEach((itm) => {
      if (itm.order_number == id) {
        itm[event.target.name] = event.target.value

        data.booking_id = itm.id
        data[event.target.name] = event.target.value
      }
    })

    this.setState({
      Booking_data: temp_data,
    })

    const checkIfPaydoStore = this.state.Booking_data?.find(
      (ele) => ele.id === data?.booking_id
    )?.additional_items?.find((ele) => ele.store_item?.store?.is_paydo_store)

    if (checkIfPaydoStore && data.booking_status === 'Cancelled') {
      const result = await Swal.fire({
        title: 'Alert!',
        text: 'Before changing status to cancel, Make sure to cancel order at Paydo',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `No`,
      })

      if (result.isConfirmed) {
        await this.updateStatus(data)
      }
    } else {
      await this.updateStatus(data)
    }
  }

  updateStatus = async (data) => {
    await axios
      .post(Constant?.getAPI() + `/booking/change-booking-details`, data, {
        headers: {
          Authorization: `Bearer ${localStorage?.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          Swal.fire('Updated !', 'Cruise details Updated', 'success')
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleCruiseChange = (event) => {
    this.setState({
      cruiseId: event,
    })
    // Auto-search when cruise changes
    this.triggerAutoSearch()
  }
  handleClear = () => {
    this.setState({ cruiseId: null })
  }

  searchData = async () => {
    this.setState(
      {
        limit: 10,
        pageNumber: 0,
      },
      () => {
        this.getBookingList()
      }
    )
  }

  clearFilters = () => {
    // Clear any pending debounce
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout)
    }

    this.setState(
      {
        cruiseId: null,
        country: '',
        type_tag: '',
        bookingStatus: '',
        nationalityId: '',
        booking_date: '',
        customer_phone: '',
        keyword: '',

        limit: 10,
        pageNumber: 0,

        Booking_data: [],
      },
      () => {
        // Auto-fetch data after clearing filters
        this.getBookingList()
      }
    )
  }

  triggerDebouncedSearch = () => {
    // Clear existing timeout
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout)
    }

    // Set new timeout for keyword search (500ms delay)
    this.debounceTimeout = setTimeout(() => {
      this.setState(
        {
          limit: 10,
          pageNumber: 0,
        },
        () => {
          this.getBookingList()
        }
      )
    }, 500)
  }

  triggerAutoSearch = () => {
    // Clear existing timeout
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout)
    }

    // Set new timeout for filter changes (300ms delay)
    this.debounceTimeout = setTimeout(() => {
      this.setState(
        {
          limit: 10,
          pageNumber: 0,
        },
        () => {
          this.getBookingList()
        }
      )
    }, 300)
  }

  handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      this.searchData()
    }
  }

  render() {
    const columns = [
      {
        name: 'order_number',
        label: 'Order No',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'cruise_name_en',
        label: 'Cruise Name',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'booking_date',
        label: 'Booking Date',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, { rowData }) => {
            return <div style={{ textWrap: 'nowrap' }}>{rowData[3] ? `${value} - ${rowData[3]}` : value}</div>
          },
        },
      },
      {
        name: 'booking_to_date',
        label: 'Booking To Date',
        options: {
          filter: true,
          sort: true,
          display: false,
        },
      },
      {
        name: 'orderPlacedDate',
        label: 'Issue Date',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (orderPlacedDate) => {
            return (
              <div>
                <Moment format="DD/MM/YYYY">{orderPlacedDate}</Moment>
              </div>
            )
          },
        },
      },
      {
        name: 'customer_phone',
        label: 'Customer Phone',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'total_booking_amount',
        label: 'Booking Amount',
        options: {
          filter: false,
          sort: true,
        },
      },
      {
        name: 'wallet_amount_applied',
        label: 'Wallet Applied Amount',
        options: {
          filter: false,
          sort: true,
        },
      },
      {
        name: 'coupon_applied_amount',
        label: 'Coupon Applied Amount',
        options: {
          filter: false,
          sort: true,
        },
      },
      {
        name: 'coupon_code',
        label: 'Coupon Code',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (coupon_code) => {
            return <div>{coupon_code ? coupon_code : '--'}</div>
          },
        },
      },
      {
        name: 'payment_status',
        label: 'Payment status',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (payment_status) => {
            return (
              <div>
                {payment_status === true ? (
                  <span className="badge badge-pill badge-success">Success</span>
                ) : (
                  <span className="badge badge-pill badge-warning">In Progress</span>
                )}
              </div>
            )
          },
        },
      },
      {
        name: 'payment_method',
        label: 'Payment Method',
        options: {
          filter: true,
          sort: false,
          customBodyRender: (value) => {
            return value && value.length > 0 ? value.join('\n') : '--'
          },
        },
      },
      {
        name: 'country',
        label: 'Country',
        options: {
          filter: false,
          sort: true,
          display: this.state.country == '',
        },
      },
      {
        name: 'booking_status',
        label: 'Booking Status',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, { rowData }) => {
            return (
              <>
                <select
                  style={{ minWidth: 150 }}
                  name="booking_status"
                  className={`form-control
                  `}
                  value={value}
                  onChange={(event) => this.changeBookingTagAndStatus(event, rowData)}
                >
                  <option value={''}>N/A</option>
                  <option value="Pending">Pending</option>
                  <option value="Confirmed">Confirmed</option>
                  <option value="Successful">Successful</option>
                  <option value="Cancelled">Cancelled</option>
                  <option value="Postponed">Postponed</option>
                  <option value="Sailed">Sailed</option>
                </select>
              </>
            )
          },
        },
      },
      {
        name: 'booking_cancel_from',
        label: 'Cancel From',
        options: {
          filter: false,
          sort: false,
          display: this.state.bookingStatus == 'Cancelled',
          customBodyRender: (value) => {
            return (
              <span style={{ textTransform: 'capitalize' }}>{value == 'system' ? 'Auto cancel' : value || '--'}</span>
            )
          },
        },
      },
      {
        name: 'type_tag',
        label: 'Type Tag',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value, { rowData }) => {
            return (
              <>
                <select
                  style={{ minWidth: 150 }}
                  name="type_tag"
                  className="form-control"
                  value={value}
                  onChange={(event) => this.changeBookingTagAndStatus(event, rowData)}
                >
                  <option value={''}>N/A</option>
                  {getTypeTags().map((itm) => (
                    <option
                      value={itm}
                      key={itm}
                    >
                      {itm}
                    </option>
                  ))}
                </select>
              </>
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Action',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (booking_id) => {
            return (
              <div>
                <Link
                  to={'/booking-ordering/' + booking_id}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="View "
                >
                  <i className="f-22 icofont icofont-eye text-dark"></i>
                </Link>
              </div>
            )
          },
        },
      },
    ]

    const options = {
      filterType: "dropdown",
      viewColumns: false,
      print: false,
      download: true,
      search: false,
      filter: false,
      count: this.state.totalCount,
      page: this.state.pageNumber,
      rowsPerPage: this.state.limit,
      serverSide: true,
      selectableRows: 'none',
      customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
        return (
          <CustomFooter
            changePage={changePage}
            changeRowsPerPage={changeRowsPerPage}
            disabled={this.state.disabled}
            count={this.state.limit}
            pageNumber={this.state.pageNumber}
            totalPages={this.state.totalPages}
          />
        )
      },

      onChangePage: (currentPage) => {
        this.setState(
          {
            pageNumber: currentPage,
          },
          () => {
            this.getBookingList()
          }
        )
      },

      onChangeRowsPerPage: (numberOfRows) => {
        this.setState(
          {
            limit: numberOfRows,
            pageNumber: 0,
          },
          () => {
            this.getBookingList()
          }
        )
      },
      textLabels: {
        body: {
          noMatch: this.state.open ? <Loader open={this.state.open} /> : 'Sorry, No Booking Data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <>
        <div className="page-body">
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-border-default">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group row">
                        <label className="col-md-3 col-form-label">Search</label>
                        <div className="col-md-9">
                          <input
                            type="text"
                            id="keyword"
                            className="form-control"
                            value={this.state.keyword}
                            name="keyword"
                            placeholder="Order No | Customer Phone/Email | Order Reference Id"
                            onKeyPress={this.handleKeyPress}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-12"
                      style={{ borderBottom: '2px solid #ddd', marginBottom: 16 }}
                    ></div>
                    <div className="col-md-4">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Booking Status</label>
                        <div className="col-sm-9">
                          <select
                            name="bookingStatus"
                            className="form-control"
                            value={this.state.bookingStatus}
                            onChange={this.handleChange}
                          >
                            <option value={''}>All</option>
                            <option value={'Pending'}>Pending</option>
                            <option value={'Successful'}>Successful</option>
                            <option value={'Cancelled'}>Cancelled</option>
                            <option value={'Confirmed'}>Confirmed</option>
                            <option value={'Postponed'}>Postponed</option>
                            <option value={'Incomplete'}>Incomplete</option>
                            <option value={'Sailed'}>Sailed</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Country</label>
                        <div className="col-sm-9">
                          <select
                            name="country"
                            className="form-control"
                            value={this.state.country}
                            onChange={this.handleChange}
                          >
                            <option value={''}>All</option>
                            {this.state.country_list.map((country) => (
                              <option
                                value={country.country_short_name}
                                key={country.country_short_name}
                              >
                                {country.country_name_en + '/' + country.country_name_ar}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Cruise Name</label>
                        <div className="col-sm-9">
                          <Select
                            name="cruiseId"
                            value={this.state.cruiseId}
                            onChange={this.handleCruiseChange}
                            options={this.state.cruiseList}
                            isMulti={false}
                            isSearchable={true}
                            isClearable
                            onClear={this.handleClear}
                            placeholder="Select Options"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Captain Nationality</label>
                        <div className="col-sm-9">
                          <select
                            name="nationalityId"
                            className="form-control"
                            value={this.state.nationalityId}
                            onChange={this.handleChange}
                          >
                            <option value={''}>All</option>
                            {this.state.nationality.map((captain) => (
                              <option
                                value={captain.id}
                                key={captain.id}
                              >
                                {captain.name_en + '/' + captain.name_ar}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Type Tag</label>
                        <div className="col-sm-9">
                          <select
                            name="type_tag"
                            className="form-control"
                            value={this.state.type_tag}
                            onChange={this.handleChange}
                          >
                            <option value={''}>All</option>
                            {getTypeTags().map((itm) => (
                              <option
                                value={itm}
                                key={itm}
                              >
                                {itm}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group row">
                        <label className="col-md-3 col-form-label">Booking Date</label>
                        <div className="col-md-9">
                          <input
                            type="date"
                            id="booking_date"
                            className="form-control"
                            value={this.state?.booking_date}
                            name="booking_date"
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    {/* <div className="col-md-4">
                      <div className="form-group row">
                        <label className="col-md-3 col-form-label">Customer</label>
                        <div className="col-md-9">
                          <input
                            type="number"
                            id="customer_phone"
                            className="form-control"
                            value={this.state.customer_phone}
                            name="customer_phone"
                            placeholder="Customer Phone | Customer Email"
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    <div className="col-md-12">
                      <div className="form-group row">
                        <div className="text-left col">
                          <Button
                            onClick={this.searchData}
                            disabled={this.state.isSearching}
                          >
                            {this.state.isSearching ? 'Searching...' : 'Search'}
                          </Button>
                          <Button
                            variant={'outlined'}
                            onClick={this.clearFilters}
                          >
                            Clear
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-body">
          <div className="row">
            <div className="col-sm-12">
              <div className="dt-responsive table-responsive">
                <MUIDataTable
                  title={'Booking List'}
                  className="table-responsive"
                  data={this.state.Booking_data}
                  columns={columns}
                  options={options}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default BookingV2
